export default "__VITE_ASSET__D8iE_NK3__"